const BASE_API = process.env.REACT_APP_ROUTE_API;
const token = localStorage.getItem('token');
const user = JSON.parse(localStorage.getItem('user'));
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
    listar: async () => {
        try {
          const req = await fetch(`${BASE_API}site/exames`, {
            method: 'GET',
            headers: headers
          });
          const json = await req.json();
                json.data = json.data ?? [];
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return(error);
        }
      },
    obterPorUrl: async (url) => {
      try {
        const req = await fetch(`${BASE_API}site/exame/${url}`, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
    gerarPedidoExame: async (data, token) => {
      try {
        let req;
          req = await fetch(`${BASE_API}site/exame/inscricao`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
          });
        const json = await req.json();
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return error;
      }
    },
};